<template id="">
  <div class="franchise-wrapper">
    <MapFranchiseService />
    <ContactUsNew />
  </div>
</template>
<script>
  import MapFranchiseService from "@/components/partials/MapFranchiseService.vue";
  import ContactUsNew from "./ContactUsNew.vue";
  export default {
    components: {
      MapFranchiseService,
      ContactUsNew,
    },
    data() {},
    beforeMount() {},
    computed: {},
    methods: {},
  };
</script>
<style></style>



// WEBPACK FOOTER //
// src/components/pages/storeLocator.vue